import { useCallback, useEffect, useState } from "react";
import io from "socket.io-client";

export const useSocket = (serverPath) => {

    const [socket, setSocket] = useState(null);
    const [online, setOnline] = useState(false);

    // Función para conectar el socket manualmente con configuración (query)
    const conectarSocket = useCallback(({ query }) => {

        // 1. Si ya existe una conexión previa, la desconectamos primero
        setSocket((prevSocket) => {
            if (prevSocket) prevSocket.disconnect();

            // 2. Permitimos 'polling' y 'websocket' para un handshake exitoso
            const socketTemp = io(serverPath, {
                transports: ['polling', 'websocket'],
                autoConnect: true,
                forceNew: true,
                query
            });

            return socketTemp;
        });

    }, [serverPath]);

    // Función para cerrar la conexión
    const desconectarSocket = useCallback(() => {
        setSocket((prevSocket) => {
            if (prevSocket) prevSocket.disconnect();
            return null;
        });
        setOnline(false);
    }, []);

    // Monitorear el estado de la conexión
    useEffect(() => {
        if (!socket) return;

        setOnline(socket.connected);

        const onConnect = () => setOnline(true);
        const onDisconnect = () => setOnline(false);

        socket.on('connect', onConnect);
        socket.on('disconnect', onDisconnect);

        return () => {
            socket.off('connect', onConnect);
            socket.off('disconnect', onDisconnect);
        };
    }, [socket]);

    return {
        socket,
        online,
        conectarSocket,
        desconectarSocket
    };
}